import moment from "moment";
import React, { useEffect, useState } from "react";
import { Accordion, Card, ListGroup, Form } from "react-bootstrap";
import { useGetFieldProfileSets } from "../../../api/getFieldProfileSets";
import { useStore } from "../../../providers/AppProvider";
import { Field, SoilProfile, SoilProfileSet } from "../../../types/types";
import { SETTING_SEASON_YEAR } from "../../../utils/settings";

type Props = {
  field: Field;
  onSoilProfileSetSelected: (soilProfileSet: SoilProfileSet | null) => void;
  onSoilProfileSelected: (soilProfile: SoilProfile | null) => void;
  onSoilProfileHover: (soilProfileIndex: number) => void;
  pushPointsVisible:boolean;
  setPushPointsVisible:Function;
};

const SoilProfileSetList = ({
  field,
  onSoilProfileSetSelected,
  onSoilProfileSelected,
  onSoilProfileHover,
  pushPointsVisible,
  setPushPointsVisible,
}: Props) => {
  const { settings } = useStore();
  const { data, isLoading } = useGetFieldProfileSets(field.id!, settings[SETTING_SEASON_YEAR]);
  
  const [visible, setVisible] = useState<boolean>(true);
  const [soilProfileSetKey, setSoilProfileSetKey] = useState<string>("0");

  useEffect(() => {
    // deselect the profileset/profile
    console.log("Y110822 settings[SETTING_SEASON_YEAR]", settings[SETTING_SEASON_YEAR]);
    onSoilProfileSetSelected(null);
    onSoilProfileSelected(null);
  }, [field, settings[SETTING_SEASON_YEAR]]);

  useEffect(() => {
    console.log("Y110822 data", data);
    console.log("Y110822 isLoading", isLoading);
    if (data && data[0] && data[0].soilprofilesetId){
      setSoilProfileSetKey(data[0].soilprofilesetId.toString())
      showSoilProfileSet(data[0].soilprofilesetId)
    }
  }, [isLoading, data]);

  const showSoilProfileSet = (soilProfileSetId: number | null) => {
    if (soilProfileSetId) {
      const profileSet = data?.find(
        (ps: SoilProfileSet) => ps.soilprofilesetId == soilProfileSetId
      );
      onSoilProfileSetSelected(profileSet ? { ...profileSet } : null);
    } else {
      onSoilProfileSetSelected(null);
    }

    onSoilProfileSelected(null);
  };

  if (isLoading) {
    return (
    <div className="d-flex flex-column mb-2 border p-2 rounded text-sm">
      <div>Loading...</div>
    </div>
    );
  }

  if (!isLoading && data && !data.length) {
    return (
      <div className="d-flex flex-column mb-2 border p-2 rounded text-sm">
        <div className="text-muted">{`No soil profile set data for season ${settings[SETTING_SEASON_YEAR]}`}</div>
      </div>
    );
  }

  return (
    <div className="d-flex flex-column mb-2 border p-2 rounded text-sm">
      <Form.Check 
            type="checkbox"
            label="Soil Profiles"
            checked={visible}
            onChange={(e:any) => {
                const nextState = !visible;
                console.log(nextState)
                setVisible(nextState);
                setPushPointsVisible(nextState);
            }}
        />
      <Accordion
        defaultActiveKey={soilProfileSetKey}
        key={soilProfileSetKey}
        onSelect={(eventKey: any) => showSoilProfileSet(eventKey)}
      >
        {data!.map((item: SoilProfileSet) => (
          <Card key={item.soilprofilesetId} className="rounded border">
            <Accordion.Toggle
              as={Card.Header}
              eventKey={`${item.soilprofilesetId}`}
              className="px-3 py-2"
              style={{ cursor: "pointer" }}
            >
              {item.name}
              <div className="text-muted text-xs">created: {moment(item.dateSampled).format("YYYY-MM-DD")}</div>
            </Accordion.Toggle>
            <Accordion.Collapse eventKey={`${item.soilprofilesetId}`}>
              <Card.Body
                className="border-bottom p-0-imp"
                style={{ maxHeight: "250px", overflow: "auto" }}
              >
                <ListGroup defaultActiveKey="#link1">
                  {item.soilprofiles.map((p: SoilProfile, index: number) => (
                    <ListGroup.Item key={index} action onClick={() => onSoilProfileSelected(p)} className="p-2">
                      <div className="align-items-center d-flex text-sm">
                        <div
                          className="border border-dark align-items-center d-flex justify-content-center ml-0 mr-2 rounded-circle text-decoration-none text-white text-xs"
                          style={{
                            backgroundColor: "#000000",  // Push point fill color (legend color)
                            width: "25px",
                            height: "25px",
                          }}
                        >
                          {p.name}
                        </div>
                        <div className="p-0 text-sm text-dark" style={{ fontSize: "15px" }}>
                          {p.startTs}
                        </div>
                      </div>
                    </ListGroup.Item>
                  ))}
                </ListGroup>
              </Card.Body>
            </Accordion.Collapse>
          </Card>
        ))}
      </Accordion>
    </div>
  );
};

export default SoilProfileSetList;
